import { AsyncStatus, defaultInitialState, State } from 'hooks/useAsync';
import { useCallback, useState } from 'react';
import OutlookService, {
  OutlookVerifyIntegrationResult,
} from './OutlookService';

const useVerifyOutlookIntegration = () => {
  const [{ error, isLoading, data, status }, setState] =
    useState<State<OutlookVerifyIntegrationResult>>(defaultInitialState);

  const verifyOutlookIntegration = useCallback(
    async (email: string) => {
      setState({
        error: null,
        status: AsyncStatus.pending,
        data: null,
        isLoading: true,
      });
      const resultPromise = OutlookService.verifyOutlookIntegration(email);
      resultPromise.then(
        (result) => {
          setState({
            error: null,
            status: AsyncStatus.resolved,
            data: result,
            isLoading: false,
          });
        },
        (error) => {
          setState({
            error: error,
            status: AsyncStatus.rejected,
            data: null,
            isLoading: false,
          });
        },
      );
    },
    [setState],
  );

  return {
    verifyOutlookIntegration,
    error,
    isLoading,
    isError:
      status === AsyncStatus.rejected ||
      (data?.data ? !data?.data.isSuccess : false),
    isSuccess: status === AsyncStatus.resolved && data?.data.isSuccess,
    data,
  };
};

export default useVerifyOutlookIntegration;
